(function () {
  function getMoneyFormat(pricingEl) {
    if (!pricingEl) return '${{amount}}';

    if (pricingEl.dataset.showCurrencyCode === 'true') {
      return pricingEl.dataset.moneyWithCurrencyFormat || pricingEl.dataset.moneyFormat || '${{amount}} USD';
    }

    return pricingEl.dataset.moneyFormat || '${{amount}}';
  }

  function formatMoney(cents, moneyFormat, currency, showCurrencyCode) {
    let formatted;

    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      formatted = Shopify.formatMoney(cents, moneyFormat);
    } else {
      formatted = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(cents / 100);
    }

    if (showCurrencyCode && currency && !formatted.includes(currency)) {
      formatted = `${formatted} ${currency}`;
    }

    return formatted;
  }

  function initSection(section) {
    const sectionId = section.dataset.sectionId;
    if (!sectionId) return;

    const variantDataEl = section.querySelector('[data-mmp-variant-data]');
    const variants = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
    const pricingEl = section.querySelector('[data-mmp-pricing]');
    const currency = pricingEl?.dataset.currency || 'USD';
    const showCurrencyCode = pricingEl?.dataset.showCurrencyCode === 'true';

    function getMoneyFormatForSection() {
      return getMoneyFormat(pricingEl);
    }

    function formatPrice(cents) {
      return formatMoney(cents, getMoneyFormatForSection(), currency, showCurrencyCode);
    }

    function formatOptionPrice(cents) {
      return formatMoney(cents, pricingEl?.dataset.moneyFormat || '${{amount}}', currency, false);
    }

    const galleryTrack = section.querySelector('[data-mmp-gallery-track]');
    const variantRadios = section.querySelector(`#variant-radios-${sectionId}`);

    function getSlides() {
      return [...section.querySelectorAll('.mmp-gallery__slide')].filter((slide) => !slide.hidden);
    }

    function getThumbs() {
      return section.querySelectorAll('.mmp-gallery__thumb');
    }

    function getVisibleThumbs() {
      return [...getThumbs()].filter((thumb) => !thumb.hidden);
    }

    function getProductForm() {
      return section.querySelector(`#product-form-${sectionId}`);
    }

    function getPurchaseOptions() {
      return section.querySelectorAll('[data-mmp-purchase-option]');
    }

    function getSellingPlanInput() {
      return section.querySelector('[data-mmp-selling-plan]');
    }

    function getAtcButton() {
      return section.querySelector(`#ProductSubmitButton-${sectionId}`);
    }

    function getPricingEls() {
      return {
        comparePriceEl: section.querySelector('[data-mmp-compare-price]'),
        currentPriceEl: section.querySelector('[data-mmp-current-price]'),
        subscriptionPillEl: section.querySelector('[data-mmp-subscription-pill]'),
        optionSubscriptionPriceEl: section.querySelector('[data-mmp-option-subscription-price]'),
        optionOnetimePriceEl: section.querySelector('[data-mmp-option-onetime-price]'),
      };
    }

    function getSelectedPurchaseType() {
      const checked = section.querySelector(`input[name="purchase-type-${sectionId}"]:checked`);
      return checked ? checked.value : 'onetime';
    }

    function getCurrentVariant() {
      const idInput = section.querySelector(`#product-form-${sectionId} input[name="id"]`);
      const variantId = idInput ? Number(idInput.value) : null;
      return variants.find((variant) => variant.id === variantId) || variants[0];
    }

    function syncSellingPlanInput(type, variant) {
      const sellingPlanInput = getSellingPlanInput();
      if (!sellingPlanInput) return;

      if (type === 'subscription' && variant?.selling_plan_id) {
        sellingPlanInput.value = variant.selling_plan_id;
        sellingPlanInput.setAttribute('name', 'selling_plan');
        sellingPlanInput.removeAttribute('disabled');
      } else {
        sellingPlanInput.value = '';
        sellingPlanInput.removeAttribute('name');
        sellingPlanInput.setAttribute('disabled', 'disabled');
      }
    }

    function setPurchaseType(type) {
      getPurchaseOptions().forEach((option) => {
        option.classList.toggle('is-selected', option.dataset.mmpPurchaseOption === type);
      });

      syncSellingPlanInput(type, getCurrentVariant());
    }

    function stripEmojis(text) {
      if (!text) return '';
      return text
        .replace(/[\p{Emoji}\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function applyFlavorLabels() {
      if (!variantRadios) return;

      const showEmojis = variantRadios.dataset.showVariantEmojis === 'true';

      section.querySelectorAll('.mmp-flavor-pill__text').forEach((el) => {
        const fullLabel = el.dataset.fullLabel || el.textContent.trim();
        el.textContent = showEmojis ? fullLabel : stripEmojis(fullLabel);
      });
    }

    function updateFlavorPills() {
      if (!variantRadios) return;

      variantRadios.querySelectorAll('.mmp-flavor-pill').forEach((pill) => {
        pill.classList.remove('is-selected');
      });

      variantRadios.querySelectorAll('.mmp-flavors__input:checked').forEach((input) => {
        const pill = input.nextElementSibling;
        if (pill) pill.classList.add('is-selected');
      });

      applyFlavorLabels();
    }

    function syncPricingFromHiddenPrice() {
      const hiddenPriceRoot = document.getElementById(`price-${sectionId}`);
      if (!hiddenPriceRoot) return false;

      const priceEl = hiddenPriceRoot.querySelector('.price');
      const { comparePriceEl, currentPriceEl } = getPricingEls();
      if (!currentPriceEl) return false;

      const isOnSale = priceEl?.classList.contains('price--on-sale');

      if (isOnSale) {
        const compareEl = hiddenPriceRoot.querySelector('.price__sale s.price-item--regular');
        const saleEl = hiddenPriceRoot.querySelector('.price__sale .price-item--sale');

        if (saleEl) {
          currentPriceEl.textContent = saleEl.textContent.trim();
        }

        if (compareEl && comparePriceEl) {
          comparePriceEl.textContent = compareEl.textContent.trim();
          comparePriceEl.hidden = false;
          comparePriceEl.classList.remove('visually-hidden');
        }
      } else {
        const regularEl = hiddenPriceRoot.querySelector('.price__regular .price-item--regular');

        if (regularEl) {
          currentPriceEl.textContent = regularEl.textContent.trim();
        }

        if (comparePriceEl) {
          comparePriceEl.hidden = true;
          comparePriceEl.classList.add('visually-hidden');
        }
      }

      return true;
    }

    function updatePricing(variant) {
      if (!variant) return;

      const { subscriptionPillEl, optionSubscriptionPriceEl, optionOnetimePriceEl } = getPricingEls();

      syncPricingFromHiddenPrice();

      if (optionOnetimePriceEl) {
        optionOnetimePriceEl.textContent = formatOptionPrice(variant.price);
      }

      if (variant.selling_plan_price != null) {
        const subMoney = formatOptionPrice(variant.selling_plan_price);

        if (subscriptionPillEl) {
          const suffix = section.querySelector('[data-mmp-pricing]')?.dataset.subscriptionSuffix || 'with Subscription';
          subscriptionPillEl.textContent = `${subMoney} ${suffix}`;
        }

        if (optionSubscriptionPriceEl) {
          optionSubscriptionPriceEl.textContent = subMoney;
        }
      }

      setPurchaseType(getSelectedPurchaseType());
    }

    function setActiveSlide(mediaId) {
      section.querySelectorAll('.mmp-gallery__slide').forEach((slide) => {
        slide.classList.toggle('is-active', Number(slide.dataset.mediaId) === Number(mediaId));
      });
    }

    function setActiveThumb(mediaId) {
      getThumbs().forEach((thumb) => {
        thumb.classList.toggle('is-active', Number(thumb.dataset.mediaId) === Number(mediaId));
      });
    }

    function scrollContainerToChild(container, child, behavior = 'smooth') {
      if (!container || !child) return;

      const targetScrollLeft = child.offsetLeft;

      if (behavior === 'auto') {
        container.scrollLeft = targetScrollLeft;
        return;
      }

      container.scrollTo({ left: targetScrollLeft, behavior });
    }

    function scrollThumbIntoView(mediaId, behavior = 'smooth') {
      const thumbsContainer = section.querySelector('.mmp-gallery__thumbs');
      const thumb = getVisibleThumbs().find((item) => Number(item.dataset.mediaId) === Number(mediaId));
      if (!thumbsContainer || !thumb) return;

      scrollContainerToChild(thumbsContainer, thumb, behavior);
    }

    function scrollToMedia(mediaId, behavior = 'smooth') {
      const slide = getSlides().find((item) => Number(item.dataset.mediaId) === Number(mediaId));
      if (!slide) return;

      if (galleryTrack) {
        scrollContainerToChild(galleryTrack, slide, behavior);
      }

      setActiveSlide(mediaId);
      setActiveThumb(mediaId);
      scrollThumbIntoView(mediaId, behavior);
    }

    function syncActiveSlideFromScroll() {
      if (!galleryTrack) return;

      const slides = getSlides();
      if (!slides.length) return;

      const trackRect = galleryTrack.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;

      let closestSlide = slides[0];
      let closestDistance = Infinity;

      slides.forEach((slide) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(slideCenter - trackCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestSlide = slide;
        }
      });

      const mediaId = Number(closestSlide.dataset.mediaId);
      setActiveSlide(mediaId);
      setActiveThumb(mediaId);
      scrollThumbIntoView(mediaId, 'smooth');
    }

    function filterGallerySlides(variant) {
      if (!variant) return;

      const variantAlt = variant.featured_media_alt || '';

      section.querySelectorAll('.mmp-gallery__slide').forEach((slide) => {
        const mediaAlt = slide.dataset.mediaAlt || '';
        const shouldShow = !variantAlt || mediaAlt === variantAlt;
        slide.hidden = !shouldShow;
      });
    }

    function filterGalleryThumbs(variant) {
      if (!variant) return;

      const variantAlt = variant.featured_media_alt || '';

      getThumbs().forEach((thumb) => {
        const mediaAlt = thumb.dataset.mediaAlt || '';
        const shouldShow = !variantAlt || mediaAlt === variantAlt;
        thumb.hidden = !shouldShow;
      });
    }

    function updateGalleryForVariant(variant) {
      if (!variant) return;

      filterGalleryThumbs(variant);
      filterGallerySlides(variant);

      if (variant.featured_media_id) {
        scrollToMedia(variant.featured_media_id, 'auto');
        return;
      }

      const firstSlide = getSlides()[0];
      if (firstSlide) {
        scrollToMedia(Number(firstSlide.dataset.mediaId), 'auto');
      }
    }

    function restoreAtcLabel() {
      const atcButton = getAtcButton();
      const atcLabel = atcButton?.dataset.mmpAtcLabel;
      const variant = getCurrentVariant();

      if (atcButton && atcLabel) {
        atcButton.querySelector('span').textContent = variant?.available
          ? atcLabel
          : window.variantStrings?.soldOut || 'Sold out';
      }
    }

    function handleVariantChange(updatePrice = true) {
      const variant = getCurrentVariant();
      updateFlavorPills();
      if (updatePrice) {
        updatePricing(variant);
      }
      updateGalleryForVariant(variant);
      restoreAtcLabel();
    }

    function bindPurchaseOptions() {
      getPurchaseOptions().forEach((option) => {
        option.addEventListener('click', () => {
          const input = option.querySelector('input');
          if (!input) return;
          input.checked = true;
          setPurchaseType(input.value);
        });
      });

      section.querySelectorAll(`input[name="purchase-type-${sectionId}"]`).forEach((input) => {
        input.addEventListener('change', () => {
          if (input.checked) setPurchaseType(input.value);
        });
      });
    }

    function bindGalleryThumbs() {
      getThumbs().forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (thumb.hidden) return;
          scrollToMedia(Number(thumb.dataset.mediaId));
        });
      });
    }

    function bindGalleryMainScroll() {
      if (!galleryTrack) return;

      let scrollTimeout;

      galleryTrack.addEventListener(
        'scroll',
        () => {
          window.clearTimeout(scrollTimeout);
          scrollTimeout = window.setTimeout(syncActiveSlideFromScroll, 80);
        },
        { passive: true }
      );

      galleryTrack.addEventListener('keydown', (event) => {
        const slides = getSlides();
        if (slides.length < 2) return;

        const activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        let nextIndex = activeIndex;

        if (event.key === 'ArrowRight') {
          nextIndex = activeIndex < slides.length - 1 ? activeIndex + 1 : 0;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = activeIndex > 0 ? activeIndex - 1 : slides.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        scrollToMedia(Number(slides[nextIndex].dataset.mediaId));
      });
    }

    function bindFormSubmit() {
      const productForm = getProductForm();
      if (!productForm) return;

      productForm.addEventListener(
        'submit',
        () => {
          syncSellingPlanInput(getSelectedPurchaseType(), getCurrentVariant());
        },
        true
      );
    }

    bindGalleryThumbs();
    bindGalleryMainScroll();
    bindPurchaseOptions();
    bindFormSubmit();

    if (variantRadios) {
      variantRadios.addEventListener('change', () => {
        window.setTimeout(() => handleVariantChange(false), 0);
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId !== sectionId) return;
        window.setTimeout(() => {
          handleVariantChange(true);
          restoreAtcLabel();
        }, 0);
      });
    }

    setPurchaseType(getSelectedPurchaseType());
    updateFlavorPills();
    handleVariantChange(false);
    syncPricingFromHiddenPrice();
  }

  function initAll() {
    document.querySelectorAll('.mm-featured-product [data-mm-featured-product-root]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.mm-featured-product [data-mm-featured-product-root]');
    if (section) initSection(section);
  });
})();
